import { render, staticRenderFns } from "./pbc.vue?vue&type=template&id=7417a9e9&scoped=true&"
import script from "./pbc.vue?vue&type=script&lang=js&"
export * from "./pbc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7417a9e9",
  null
  
)

export default component.exports